import { render, staticRenderFns } from "./account-balance-transfer.vue?vue&type=template&id=b037ad02"
import script from "./account-balance-transfer.vue?vue&type=script&lang=ts"
export * from "./account-balance-transfer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports